import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';

import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import useAlerts from 'utils/hooks/useAlerts';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';
import { ResourceType } from 'utils/types';
import { org2trees as org2notifications } from './queries';
import RelationTable from 'components/RelationTable/RelationTable';
import useRelations from 'utils/hooks/useRelations';
import { useRelationData, createRelationQueryData, createOrgOwnerRelationQueryData } from './queries';
import { notificationsKeys } from 'components/Admin/Notifications/queries';


const OrgToNotificationsRelations = ({ breadcrumbs }) => {
  const api = useAPI();
  const { orgId } = useParams();
  const [alerts,, addErrorAlert] = useAlerts();

  const [notificationsQuery, relationQuery, ownerQuery] = useQueries({
    queries: [
      { queryKey: notificationsKeys.notifications(), queryFn: createQueryRequest(api.core.getNotifications) },
      { queryKey: org2notifications.org(createRelationQueryData(ResourceType.Notification, orgId)), queryFn: createQueryRequest(api.core.findRelationships) },
      { queryKey: org2notifications.org(createOrgOwnerRelationQueryData(ResourceType.Notification)), queryFn: createQueryRequest(api.core.findRelationships) }
    ]
  });

  const notifications = useRelationData({
    isLoading: notificationsQuery.isLoading || relationQuery.isLoading || ownerQuery.isLoading,
    resources: notificationsQuery.data,
    resourceRelations: relationQuery.data,
    ownedRelations: ownerQuery.data,
    resourceType: ResourceType.Notification
  });

  const { updateRelations, deleteRelations } = useRelations({
    refetchFn: relationQuery.refetch,
    queryKey: org2notifications.org(createRelationQueryData(ResourceType.Notification)),
    onError: addErrorAlert
  });

  return (
    <ContentPage
      breadcrumb={breadcrumbs}
    >
      { alerts }
      <RelationTable
        orgId={orgId}
        resources={notifications}
        isLoading={notificationsQuery.isLoading || relationQuery.isLoading || ownerQuery.isLoading}
        updateRelationsFn={updateRelations.mutate}
        deleteRelationsFn={deleteRelations.mutate}
      />
    </ContentPage>
  );
};

export default OrgToNotificationsRelations;
